/**
 * Opens a URL in the platform external browser (Custom Tabs on Android TWA).
 */
export function openExternalUrl(url) {
  if (!url || typeof url !== "string") {
    return false;
  }

  const opened = window.open(url, "_blank", "noopener,noreferrer");
  if (opened) {
    opened.opener = null;
    return true;
  }

  window.location.assign(url);
  return true;
}
